export default "__VITE_ASSET__URCRe5$U__"